<template>
  <div v-for="(item, idx) in elements" :key="idx" class="bar-row">
    <div
      class="label"
      :style="{ color: item.color }"
    >
      {{ item.name }}
    </div>
    <div class="bar-wrapper">
      <v-progress-linear
        :model-value="item.value"
        :color="item.color"
        height="10"
        rounded
      />
    </div>
    <div
      class="percent"
      :style="{ color: item.color }"
    >
      {{ item.value.toFixed(1) }}%
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  jijangFive: {
    type: Object,
    required: true,
  },
})

const colorMap = {
  목: 'rgba(var(--v-theme-fiveColor03), 1)',
  화: 'rgba(var(--v-theme-fiveColor01), 1)',
  토: 'rgba(var(--v-theme-fiveColor05), 1)',
  금: 'rgba(var(--v-theme-fiveColor04), 1)',
  수: 'rgba(var(--v-theme-fiveColor02), 1)',
}


const elements = computed(() => {
  if (!props.jijangFive) return []

  return Object.entries(props.jijangFive)
    .map(([name, value]) => ({
      name,
      value,
      color: colorMap[name] || 'gray',
    }))
    .sort((a, b) => b.value - a.value)
})

const updateProgressStyles = () => {
  nextTick(() => {
    const progressBars = document.querySelectorAll('.v-progress-linear__determinate')

    progressBars.forEach((bar) => {
      bar.style.borderTopRightRadius = '5px'
      bar.style.borderBottomRightRadius = '5px'
    })
  })
}

onMounted(updateProgressStyles)

watch(() => props.jijangFive, updateProgressStyles)
</script>

<style scoped>
.bar-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  min-width: 300px;
}

.label {
  width: 24px;
  text-align: left;
  font-weight: 600;
}

.bar-wrapper {
  flex: 1;
  margin: 0 8px;
  width: 100%;
}

.percent {
  width: 48px;
  text-align: right;
  font-weight: 600;
}

.v-progress-linear__determinate {
  border-radius: 100%;
}
</style>
